<template>
    <div class="availability-details">
        <duration-row v-if="isShortTerm" :booking="bookings[0]"/>

        <cost-row
            :space="space"
            :rental="rental"
            :quote="quote"
        />

        <template v-if="!isShortTerm">
            <arrangement-fee-row />

            <billing-frequency-row/>

            <deposit-row v-if="monthlyDepositRequired" />

            <amount-due-row :space="space"/>
        </template>
    </div>
</template>

<script>
    import CheckerDetailRow from './CheckerDetailRow';
    import LongTermBookingTotalLabel from '../../space/LongTermBookingTotalLabel';
    import DurationRow from './availability-details/DurationRow';
    import CostRow from './availability-details/CostRow';
    import ArrangementFeeRow from './availability-details/ArrangementFeeRow';
    import BillingFrequencyRow from './availability-details/BillingFrequencyRow';
    import AmountDueRow from './availability-details/AmountDueRow';
    import { mapGetters } from 'vuex';
    import { mapReducers } from '../../../modules/reducer';
    import DepositRow from './availability-details/DepositRow';

    export default {
        name: 'availability-details',

        components: {
            DepositRow,
            AmountDueRow,
            BillingFrequencyRow,
            CostRow,
            ArrangementFeeRow,
            DurationRow,
            LongTermBookingTotalLabel,
            CheckerDetailRow,
        },

        props: {
            rental: {
                type: String,
                default() {
                    return '';
                },
            },

            space: {
                type: Object,
                default() {
                    return {};
                },
            },

            quote: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'bookings',
            ]),

            ...mapGetters('booking', [
                'isShortTerm',
                'quoteValue',
                'seasonIntervalData',
                'duration',
                'monthlyDepositRequired',
            ]),
        },
    };
</script>

<style lang="less">
    @import "~assets/less/variables";

    .availability-details {
        del {
            opacity: 0.5;
            font-size: 0.9em;
            font-weight: 400;
            text-decoration: line-through;
        }
        .text-green {
            color: @YPS-secondary;
        }
        small {
            display: block;
            font-weight: normal;
            color: #414b4e;
            font-size: 10px;
        }
    }
</style>
